// Spanish translations for the 20 kindness challenges + 18 family activities.
// Keyed by id — merged into the English data at read time.

export const CHALLENGE_ES = {
  1: {
    title: "Escribe una nota de ánimo para un desconocido",
    description: "Toma una nota adhesiva, escribe algo amable y déjala donde un desconocido la encuentre. Las palabras pequeñas llegan lejos.",
    steps: [
      "Toma una nota adhesiva o un pedazo de papel.",
      "Escribe algo cálido y específico — 'Tú importas,' 'Alguien te apoya,' o un cumplido corto.",
      "Déjala en un lugar público — un libro de la biblioteca, una mesa de café, un espejo del baño.",
      "Saca una foto rápida antes de dejarla.",
    ],
  },
  2: {
    title: "Recoge basura en tu vecindario por 10 minutos",
    description: "Toma una bolsa y limpia una cuadra. Tu vecindario — y todos los que caminan por ahí — te lo agradecerán.",
    steps: [
      "Toma una bolsa y (si tienes) guantes.",
      "Elige una cuadra, banqueta o sendero de parque.",
      "Llena tu bolsa durante al menos 10 minutos.",
      "Toma una foto antes/después del lugar.",
    ],
  },
  3: {
    title: "Elogia a 3 personas que no conozcas hoy",
    description: "Un cajero, un vecino, un compañero. Nota algo real y dilo en voz alta.",
    steps: [
      "Busca algo genuino — su ropa, su bondad, su sonrisa.",
      "Dilo mirándolos a los ojos y con sinceridad.",
      "Hazlo tres veces antes de que termine el día.",
      "Toma una selfie o un video corto contando cómo se sintió.",
    ],
  },
  4: {
    title: "Ayuda a un vecino con la compra o sostén una puerta",
    description: "Busca una pequeña oportunidad de ayudar hoy. Ofrécete antes de que te pidan.",
    steps: [
      "Mantén los ojos abiertos — alguien con bolsas pesadas, una carriola, un andador.",
      "Pregunta con amabilidad: '¿Puedo echarte una mano?'",
      "Ayuda sin esperar nada a cambio.",
      "Toma una foto del lugar (no de la persona si prefieren).",
    ],
  },
  5: {
    title: "Dibuja una tarjeta de agradecimiento para un maestro o bibliotecario",
    description: "Toma crayones y haz una tarjeta para alguien que trabaja duro por ti. Entrégala en persona si puedes.",
    steps: [
      "Dobla una hoja por la mitad para hacer una tarjeta.",
      "Dibuja algo colorido y escribe 'Gracias' adentro.",
      "Entrégala en persona o déjala en su escritorio.",
      "Toma una foto de tu tarjeta terminada.",
    ],
  },
  6: {
    title: "Comparte tu bocadillo o almuerzo con alguien que lo necesite",
    description: "¿Ves a un amigo sin bocadillo? Comparte el tuyo. La bondad empieza en la mesa.",
    steps: [
      "Nota a alguien en tu mesa que podría usar un bocado.",
      "Ofrece compartir — sin drama, solo amabilidad.",
      "Siéntense y coman juntos.",
      "Toma una foto del bocadillo compartido (o una selfie juntos).",
    ],
  },
  7: {
    title: "Léele en voz alta a un hermano menor por 15 minutos",
    description: "Elige un libro favorito y léelo con emoción. Los pequeños recuerdan estos momentos por siempre.",
    steps: [
      "Elige un libro que te guste o que les guste.",
      "Usa voces distintas para los personajes — hazlo divertido.",
      "Lee al menos 15 minutos con toda tu atención.",
      "Toma una foto de los dos (o del libro abierto).",
    ],
  },
  8: {
    title: "Dona 5 artículos a un refugio o despensa de alimentos",
    description: "Revisa tu clóset o alacena. Elige 5 cosas en buen estado y déjalas en un refugio local.",
    steps: [
      "Encuentra 5 artículos en buen estado que ya no necesites.",
      "Guárdalos juntos en una bolsa.",
      "Déjalos en un refugio, despensa o contenedor local.",
      "Toma una foto de la bolsa antes o después de entregarla.",
    ],
  },
  9: {
    title: "Organiza una limpieza pequeña en un parque o espacio comunitario",
    description: "Reúne a un amigo o dos, toma guantes y bolsas, y dale amor a un espacio público.",
    steps: [
      "Invita a 1-3 amigos o familiares.",
      "Elige un parque, patio o cuadra que necesite atención.",
      "Trae guantes, bolsas y agua — dedícale 30-60 minutos.",
      "Toma una foto grupal con las bolsas de basura.",
    ],
  },
  10: {
    title: "Hornea o prepara algo y compártelo con un vecino",
    description: "Galletas, pan de plátano, un dibujo — llévalo con una sonrisa.",
    steps: [
      "Hornea o prepara algo casero.",
      "Envuélvelo bonito — papel, cinta, una tarjeta.",
      "Camina y déjalo en la puerta de un vecino.",
      "Toma una foto de lo que hiciste antes de entregarlo.",
    ],
  },
  11: {
    title: "Escribe cartas a los adultos mayores de un asilo local",
    description: "Una carta a mano puede alegrarle la semana a alguien. Escribe con cariño y déjalas.",
    steps: [
      "Escribe 3-5 cartas cortas a mano (tono cálido, cualquier tema).",
      "Firma solo con tu primer nombre.",
      "Llama a un asilo cercano y pregunta si puedes dejarlas.",
      "Toma una foto del montón de cartas terminadas.",
    ],
  },
  12: {
    title: "Enséñale algo que se te da bien a un niño más pequeño",
    description: "¿Baloncesto? ¿Trenzas? ¿Un truco de mates? Comparte lo que sabes con alguien que te admira.",
    steps: [
      "Elige una habilidad que disfrutes.",
      "Divídela en pasos pequeños — enseña con paciencia.",
      "Practica al menos 15 minutos.",
      "Toma una foto o video corto de la mini-clase.",
    ],
  },
  13: {
    title: "Crea un kit de bondad y regálaselo a alguien",
    description: "Llena una bolsita con notas, bocadillos y detalles pequeños. Regálala a un amigo, maestro o desconocido.",
    steps: [
      "Encuentra una bolsita o caja.",
      "Llénala con 3-5 cosas: una nota, un bocadillo, un dulce, una calcomanía.",
      "Regálala a alguien que necesite un ánimo.",
      "Toma una foto del kit antes de entregarlo.",
    ],
  },
  14: {
    title: "Crea un muro de gratitud en tu escuela o casa",
    description: "Pon notas adhesivas donde la gente pueda escribir lo que agradece. Míralo crecer.",
    steps: [
      "Elige una pared, refrigerador o tablero.",
      "Pon un letrero: '¿Qué agradeces hoy?'",
      "Deja notas y plumas cerca.",
      "Toma una foto del muro (vacío y lleno, si puedes).",
    ],
  },
  15: {
    title: "Ayuda a un adulto mayor con tecnología o quehaceres por 30 minutos",
    description: "Configura un teléfono, saca la basura, riega plantas. Ayuda real, tiempo real, bondad real.",
    steps: [
      "Pregúntale a un familiar, vecino o asilo si necesitan ayuda.",
      "Llega a tiempo y con paciencia — sin prisa.",
      "Ayuda con tecnología, quehaceres o mandados por 30+ minutos.",
      "Toma una foto respetuosa del entorno (no de su cara si no quieren).",
    ],
  },
  16: {
    title: "Organiza una colecta de bondad en el vecindario",
    description: "Junta libros, ropa o comida de los vecinos. Entrégalo donde lo necesiten.",
    steps: [
      "Elige qué recolectar (libros, ropa, comida no perecedera).",
      "Haz volantes o un chat grupal — pon una fecha.",
      "Recolecta de los vecinos durante varios días.",
      "Entrega en grupo y toma una foto con lo recolectado.",
    ],
  },
  17: {
    title: "Lidera una actividad de bondad en la escuela",
    description: "Planea una actividad o charla de 10 minutos. Involucra a tu clase. Las ideas viajan más lejos que una persona.",
    steps: [
      "Pídele a tu maestro 10 minutos.",
      "Planea una actividad corta — un juego, una charla, un reto.",
      "Guíala y haz que todos participen.",
      "Toma una foto o video del grupo (con permiso).",
    ],
  },
  18: {
    title: "Haz un video o cartel sobre bondad y compártelo",
    description: "Haz algo que te enorgullezca y compártelo con el mundo. Inspira a personas que nunca conocerás.",
    steps: [
      "Piensa un mensaje — una idea de bondad que valga compartir.",
      "Haz un cartel, video corto o reel.",
      "Publícalo en redes o cuélgalo en tu escuela/vecindario.",
      "Guarda una captura o foto de la pieza terminada.",
    ],
  },
  19: {
    title: "Sé voluntario en un evento comunitario por 2+ horas",
    description: "Inscríbete, preséntate y ayuda. Dos horas pueden cambiar cómo ves tu ciudad.",
    steps: [
      "Encuentra un evento local que necesite voluntarios.",
      "Inscríbete y llega a tiempo.",
      "Dedica al menos 2 horas de ayuda enfocada.",
      "Toma una foto en el evento (un cartel, tu gafete o una foto grupal).",
    ],
  },
  20: {
    title: "Con un compañero, hagan 3 actos de bondad en un día",
    description: "Elige a un compañero, elijan 3 actos y háganlos juntos. La bondad es mejor cuando se comparte.",
    steps: [
      "Elige un amigo, hermano o familiar como compañero.",
      "Elijan 3 actos rápidos — los pequeños cuentan.",
      "Háganlos los 3 juntos en un día.",
      "Toma una foto de cada acto (o un collage).",
    ],
  },
};

export const AGE_ES = {
  "All Ages": "Todas las edades",
  "PreK-2": "PreK-2°",
  "K-3": "K-3°",
  "K-5": "K-5°",
  "3rd-5th": "3°-5°",
  "3rd-8th": "3°-8°",
  "5th-8th": "5°-8°",
  "6th-8th": "6°-8°",
  "PreK-5": "PreK-5°",
  "K-8": "K-8°",
};

export const ACTIVITY_ES = {
  // 🏛️ Indy Icons
  1: {
    name: "Sube al Monumento",
    description: "Toma el elevador o las escaleras hasta la plataforma de observación. En un día despejado se ve la ciudad a millas de distancia.",
    bonus_title: "Reto de escalones",
    bonus_body: "Son 331 escalones hasta la cima — adivinen antes de subir, cuenten juntos, y elijan su vista favorita del centro desde la plataforma.",
  },
  2: {
    name: "Explora el Museo del Indianapolis Motor Speedway",
    description: "Vean autos reales de la Indy 500, aprendan cómo empezó la carrera, y caminen por el mismo paddock que los pilotos.",
    bonus_title: "Besa los Ladrillos",
    bonus_body: "Salgan al Yard of Bricks en la línea de meta y tómense una foto familiar arrodillados, como un piloto ganador.",
  },
  3: {
    name: "Visita la Feria del Estado de Indiana como pro",
    description: "Ganado, todo frito, juegos mecánicos y una rueda de la fortuna con vista al recinto ferial.",
    bonus_title: "Caza del listón azul",
    bonus_body: "Elijan una competencia (calabaza más grande, gallina más rara, mejor pay), busquen el ganador del listón azul, y voten por su favorito de segundo lugar.",
  },

  // 🎨 Creative Days
  4: {
    name: "Haz un día de museo",
    description: "Elige un museo y sigue la curiosidad de los niños de sala en sala. Hay días gratis — revisa los horarios.",
    bonus_title: "Historia de un objeto",
    bonus_body: "Cada niño elige la única cosa en todo el museo que no puede dejar de mirar. Dibújenla de regreso a casa y cuenten su historia en la cena.",
  },
  5: {
    name: "Recorre la noche de arte First Friday",
    description: "El primer viernes de cada mes, galerías del centro abren gratis — arte, música, food trucks y artistas en vivo.",
    bonus_title: "Búsqueda del tesoro en galerías",
    bonus_body: "Encuentren una pieza con tres colores, una que les haga sentir algo, y una que su hijo/a podría imaginar creando. Fotografíen cada una.",
  },
  6: {
    name: "Encuentra los columpios musicales",
    description: "Columpios que tocan notas al balancearse — cuantas más personas se columpien juntas, más rico el sonido.",
    bonus_title: "Compongan juntos",
    bonus_body: "Todos se columpian al ritmo para hacer una \"canción\" familiar. Junten cinco columpios en marcha y graben 30 segundos con el teléfono.",
  },
  7: {
    name: "Haz un paseo de cuentos",
    description: "Páginas de un libro ilustrado colocadas en un sendero — caminen, lean, caminen, lean. Lectura y pasos a la vez.",
    bonus_title: "Dibuja la página",
    bonus_body: "Después de cada página en el sendero, un niño describe un nuevo dibujo que agregaría. Bosquejen el mejor en una servilleta durante el almuerzo.",
  },

  // 🍩 Eats & Treats
  8: {
    name: "Sal a un tour de donas",
    description: "Long's Bakery, General American Donut, Jack's — elige dos o tres y prueben una en cada una.",
    bonus_title: "Torneo por eliminación",
    bonus_body: "Compren una dona por tienda, corten cada una en cuartos, y clasifíquenlas 1-4 en familia. La dona ganadora se va a casa con ustedes.",
  },
  9: {
    name: "Persigue un antojo helado",
    description: "Ritter's Frozen Custard, Nicey Treat, The Sugar Shack — elige tu paradita favorita para una bola de helado.",
    bonus_title: "Reto de sabor",
    bonus_body: "Cada niño pide un sabor que nunca ha probado. Denle una nota del 1 al 10 en el camino a casa y defiendan su calificación.",
  },
  10: {
    name: "Haz un picnic con tu gente",
    description: "Empaquen una manta, sándwiches y una comida boba (las palomitas cuentan). Sin plan más que el pasto.",
    bonus_title: "Safari de nubes",
    bonus_body: "Acuéstense boca arriba después de comer. Cada persona nombra algo que ve en las nubes. Fotografíen a la ganadora.",
  },

  // ⚡ Action-Packed Fun
  11: {
    name: "Anima al equipo local",
    description: "Indianapolis Indians · Fever · Colts. El béisbol en Victory Field es súper económico. Los partidos de Fever son ruidosos. El entrenamiento de los Colts es gratis.",
    bonus_title: "Momento de fan-cam",
    bonus_body: "Pónganse una meta — salir en la pantalla gigante, atrapar un foul, o encontrar a la mascota para una foto. Persíganla antes de que acabe el juego.",
  },
  12: {
    name: "Prueben el pickleball",
    description: "La mitad del tamaño del tenis, el doble de risas. Las canchas públicas de Indianápolis reciben walk-ups.",
    bonus_title: "Ronda de servicio bobo",
    bonus_body: "Cada miembro de la familia sirve por abajo, con la mano contraria, o con los ojos cerrados (con un vigilante). El primero en llegar a 5 elige el postre.",
  },
  13: {
    name: "Boliche gratis todo el verano",
    description: "Registra a los niños una vez en kidsbowlfree.com — juegan dos partidos gratis al día en boliches participantes todo el verano.",
    bonus_title: "Renombra el turno",
    bonus_body: "Antes de tu tiro, nómbrale al turno algo loco (\"El Twizzler,\" \"El codo de la abuela\"). La risa más grande gana.",
  },

  // 🌊 Water & Nature
  14: {
    name: "Recorre las áreas de chapoteo",
    description: "Broad Ripple, Watkins, Ellenberger — áreas de chapoteo gratuitas por todos los Indy Parks.",
    bonus_title: "Olimpiadas de chapoteo",
    bonus_body: "Inventen tres eventos (mejor atrapada de fuente, mejor panzazo, congelada más chistosa). Entreguen medallas imaginarias.",
  },
  15: {
    name: "Explora un arroyo",
    description: "Zapatos viejos puestos. Busquen sardinas, cangrejos de río y las piedras más lisas para lanzar.",
    bonus_title: "Historia de piedra",
    bonus_body: "Cada niño elige una piedra del arroyo. Pínteme una cara, dénle un nombre y una cosa que quisiera que la gente supiera.",
  },
  16: {
    name: "Haz una caminata amigable con niños",
    description: "Eagle Creek Park · Fort Ben · Holliday. Circuitos cortos, planos y con sombra. Traigan agua, protector solar y un snack para la mitad.",
    bonus_title: "Yo veo, veo en el sendero",
    bonus_body: "Antes de empezar, cada uno susurra un objetivo (una telaraña, un hongo, una hoja en forma de corazón). El primero en verlo elige el snack.",
  },
  17: {
    name: "Explora un centro de naturaleza",
    description: "Southeastway · Holliday · Eagle Creek. Animales vivos, exhibiciones a la altura de los niños, y un guardabosques casi siempre listo para preguntas.",
    bonus_title: "Pregúntale al guardabosques",
    bonus_body: "Lleguen con tres preguntas. Háganlas antes de irse. Anoten las respuestas en el camino a casa.",
  },

  // 🌻 Everyday Adventures
  18: {
    name: "Pasea por un mercado de agricultores",
    description: "Original · Broad Ripple · Circle City. Mañanas de sábado, primavera a otoño. Granjeros, panaderos, música en vivo, perros por todas partes.",
    bonus_title: "Reto de comida nueva",
    bonus_body: "Cada miembro de la familia elige una fruta o verdura que nunca ha probado. Pregúntenle al granjero cómo crece antes de comprarla.",
  },
  19: {
    name: "Recorre un jardín",
    description: "Newfields · Garfield Park · IMA gardens. Jardines cuidados, senderos hundidos, y cien rincones tranquilos para el descanso después del almuerzo.",
    bonus_title: "Búsqueda de arcoíris",
    bonus_body: "Encuentren una flor en cada color del arcoíris. Fotografíen las siete y acomódenlas en un arcoíris en el camino a casa.",
  },
  20: {
    name: "Juega en Monument Circle",
    description: "El corazón de Indianápolis — fuentes majestuosas, calles radiales, carritos de comida, músicos callejeros en las noches de verano.",
    bonus_title: "Búsqueda del tesoro en Monument Circle",
    bonus_body: "Encuentren las cuatro estatuas en las esquinas del Monumento, cuenten las fuentes, y lean una placa en voz alta. Punto extra si ven un perro.",
  },
};

// Filter option labels (values stay in English to keep filtering logic)
export const FILTER_LABELS_ES = {
  "Any": "Cualquiera",
  "Weekday": "Entre semana",
  "Weekend": "Fin de semana",
  "Anytime": "Cualquiera",
  "Indoor": "Interior",
  "Outdoor": "Exterior",
  "Mixed": "Mixto",
  "Family": "Familia",
  "Group": "Grupo",
  "Solo": "Solo",
  "Free": "Gratis",
  "Low Cost": "Bajo costo",
  "< 30 min": "< 30 min",
  "30–60 min": "30–60 min",
  "1–2 hrs": "1–2 hrs",
  "2+ hrs": "2+ hrs",
};

// Spinner wheel categories, translated. Keys match the id in data/activities.js.
export const CATEGORY_ES = {
  icons:     { label: "Íconos de Indy",             short: "Indy" },
  creative:  { label: "Días Creativos",             short: "Creativo" },
  eats:      { label: "Comidas y Antojos",          short: "Antojos" },
  action:    { label: "Diversión Activa",           short: "Activo" },
  water:     { label: "Agua y Naturaleza",          short: "Agua" },
  adventure: { label: "Aventuras Diarias",          short: "Diario" },
};
